module.exports = __webpack_public_path__ + "static/media/logo-web.45274db4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/black-weekend/logo-web.png
// module id = 1455
// module chunks = 0